import React, { useEffect } from "react";
import { NavLink } from "react-router-dom";
import './style.css'

export const Navbar = () => {
  const showNavBarBackground = () => {
    const navbar = document.getElementById('navBar')

    if (window.pageYOffset > 250) {
      navbar.classList.remove('NavigationBar--Removebackground')
      navbar.classList.add('NavigationBar--Addbackground')
    } else {
      navbar.classList.remove('NavigationBar--Addbackground')
      navbar.classList.add('NavigationBar--Removebackground')
    }
  }

  useEffect(() => {
    window.addEventListener("scroll", showNavBarBackground)
  })

  return (
    <div id='navBar' className="NavigationBar">
      <div className="NavigationBar_Container Container">
        <NavLink
          exact
          to="/"
          className="NavigationBar_Container_Item"
          activeClassName="NavigationBar_Container_ItemSelected"
        >
          Home
        </NavLink>
        <NavLink
          to="/projects"
          className="NavigationBar_Container_Item"
          activeClassName="NavigationBar_Container_ItemSelected"
        >
          Projects
        </NavLink>
      </div>
    </div>
  );
};
